import { STORE_USER, STORE_USER_ERROR } from '../actions/types'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    user: null,
    isAuthenticated: false,
}

export default createReducer(initialState, {
    [STORE_USER]: (state, action) => {
        state.isAuthenticated = true
        state.user = action.payload
    },
    [STORE_USER_ERROR]: (state, action) => {
        state.isAuthenticated = false
    },
})
